import { styled } from '@mui/material/styles';
import TableCell, {tableCellClasses} from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

export const StripedTableCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== "nowrap",
})(({ theme, nowrap }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "rgb(223, 225, 226)",
    color: theme.palette.common.black,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    borderTop:1,
  },
  [`&.MuiTableCell-root`]: {
    borderLeft: "1px solid rgb(223, 225, 226)",
    whiteSpace: nowrap ? "nowrap" : "normal",
  }
}));

export const StripedTableHeadCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== "nowrap",
})(({ theme, nowrap }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "rgb(223, 225, 226)",
    color: theme.palette.common.black,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontWeight: 600,
    borderTop:1,
  },
  [`&.MuiTableCell-root`]: {
    borderLeft: "1px solid rgb(223, 225, 226)",
    whiteSpace: nowrap ? "nowrap" : "normal",
  }
}));

export const StripedTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    borderLeft: "1px solid rgb(223, 225, 226)",
  },
}));
